import { render } from "./NoAccount.vue?vue&type=template&id=19d34879"
const script = {}

import "./NoAccount.vue?vue&type=style&index=0&id=19d34879&lang=css"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__